<template>
  <div class="footer">
    <div class="container footer_parts">

      <div class="part footer_home">
        <div class="picture">
            <img :src="mainpicture" alt="logo" />
          </div>
          <div class="txt">
            <p class="text-justify">
              由於全球氣候變遷，使得天氣變化巨大、難以預料，許多農民藉由過去的傳統經驗已經不足以應付，因此農業也應該有相應的措施，
              藉由科技來蒐集農場資料，透過資料的分析和幫助，期望能達到作物質量上的成長，農業與科技結合已成為全球趨勢。
            </p>
          </div>
      </div>

      <div class="part footer_contactus">
        <div class="contactus-inside">
          <h1>洽詢資訊</h1>
          <h2>立即與我們聯絡！</h2>
          <div class="group" v-for="(item, index) in groupItems" :key="index">
            <h3>{{ item.title }}</h3>
            <h4>{{ item.content }}</h4>
          </div>
        <br/>
        </div>
      </div>

      <!-- <div class="part footer_news">
        <h1><router-link to="/news">新聞快訊</router-link></h1>
        <div class="group" v-for="(content, index) in newscardContent" :key="index">
          <div class="pic">
            <a :href="content.url" target="_blank">
              <img :src="content.image" />
            </a>
          </div>
          <div class="txt">
            <a :href="content.url" target="_blank">
              <h2>{{ content.topic }}</h2>
              <h5>{{ content.date }}</h5>
            </a>
          </div>
        </div>
      </div> -->

    </div>
  </div>
</template>

<script>
import products1and1 from '@/assets/products/products-1/product1.png';

export default {
  // props: {
  //   newscard: {
  //     type: Object,
  //     default: () => ({
  //       topic: '這是標題',
  //       image: 'https://picsum.photos/800/300?random=31',
  //       date: 'date',
  //     }),
  //   },
  // },
  data() {
    return {
      // newscontent: this.newscard,
      groupItems: [
        {
          title: '連絡電話',
          content: '(03) 657-3989',
        },
        {
          title: '傳真',
          content: '(03) 657-3889',
        },
        {
          title: '電子郵件',
          content: '3a.judy@3farms.com.tw',
        },
        {
          title: '地址',
          content: '302007 新竹縣竹北市縣政二路488號2樓',
        },
      ],
      mainpicture: products1and1,
      newscardContent: [
        // {
        //   topic: '這是標題1',
        //   categories: '這是種類',
        //   content:
        //     '定時拍攝的照片透過雲端紀錄且回傳展示，可以直接看見作物的微細變化，更在歷史照片回顧中，可以追蹤作物生長情形',
        //   image: 'https://picsum.photos/500/500?random=18',
        //   date: '2020 / 06 / 23',
        // },
      ],
    };
  },
  // created() {
  //   const api = 'https://brycehuang.com/api/getNews/';
  //   this.axios.get(api).then((response) => {
  //     console.log(response.data.data);
  //     const arr = [];
  //     response.data.data.forEach((news) => {
  //       arr.push(news);
  //     });
  //     const array = arr.reverse();
  //     this.newscardContent = array.slice(0, 3);
  //   });
  // },
};
</script>


<style scoped lang="scss">
.footer {
  background-color: #1d2a1a;
  padding: 20px;
  color: #aaa;
  font-size: 0.9rem;
  line-height: 30px;
  text-align: left;
  .footer_parts {
    display: flex;
    justify-content: center;
    .part{
      padding: 15px;
    }
    .footer_home{
      width: 50%;
      flex-direction: column;
      .picture {
        height: 200px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    h1 {
      margin-bottom: 20px;
      font-size: 1.5rem;
    }
    .footer_contactus {
      flex-grow: 1;
      .contactus-inside{
        width: 60%;
        margin: auto;
        h2 {
          font-size: 1.2rem;
        }
        .group {
          margin-top: 30px;
          h3 {
            margin-bottom: 10px;
            font-size: 1.1rem;
          }
          h4 {
            font-size: 0.9rem;
          }
        }
      }
    }
    .footer_news {
      width: 25%;
      a {
        text-decoration: none;
        color: inherit;
      }
      a:hover {
        color: #ddd;
      }
      .group {
        display: flex;
        margin: 20px;
        margin-left: 0;

        .pic {
          margin-right: 20px;
          // width: 80px;
          // height: 50px;
          img {
            width: 80px;
            height: 50px;
          }
        }
        .txt {
          h2 {
            margin-bottom: 10px;
            font-size: 0.8rem;
          }
          h5 {
            font-size: 0.5rem;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 850px) {
  .footer .footer_parts{
    justify-content: space-between;
    max-width: 850px;
    .footer_news {
      display: none;
    }
    .footer_home,
    .footer_contactus {
      width: 50%;
    }
  }
}


@media screen and (max-width: 600px) {
  .footer .footer_parts{
    padding: 0;
    flex-wrap: wrap;
    .part{
      padding: 0px;
    }
    .footer_home,
    .footer_contactus {
      margin: 20px 0;
      width: 100%;
      .contactus-inside{
        margin: 0;
        width: 90%;
      }
    }
  }
}

</style>
